// extracted by mini-css-extract-plugin
module.exports = {"Yay":"YayPage_Yay__3PvdL","Container":"YayPage_Container__Fj3ka"};